import styled from 'styled-components';

import { InfoOutlined } from '@mui/icons-material';
import { InputAdornment, Tooltip, tooltipClasses } from '@mui/material';
import { wellzTheme as wellzThemeMui } from '@wellz-theme/mui';
import { useIntl } from 'react-intl';

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 125,
    height: 100,
    padding: wellzThemeMui.spacing(1),
    borderRadius: 8,
    fontSize: wellzThemeMui.typography.body2.fontSize,
    fontFamily: wellzThemeMui.typography.fontFamily,
    fontWeight: 400,
    textAlign: 'center',
    color: 'white',
  },
});

const Tooltipicon = () => {
  const intl = useIntl();

  return (
    <InputAdornment position="end">
      <CustomWidthTooltip
        placement="top"
        title={intl.formatMessage({
          id: 'CPPLATAFORM.CPNEWTIMECONFIRM.PATIENTTOOLTIP',
        })}
      >
        <InfoOutlined />
      </CustomWidthTooltip>
    </InputAdornment>
  );
};

export default Tooltipicon;
